export default {
  back: 'Volver a campañas',
  title: 'Campaña',
  sent_at: 'Enviado {{time}}',
  breakdown_title: 'Resumen de entrega',
  pending_receipts: {
    title: 'Estadísticas de entrega en camino',
    description:
      'Esta campaña acaba de enviarse. Los proveedores de push confirman la entrega unos 15 minutos después del envío, por lo que los números se completarán alrededor de las {{time}} — no se requiere ninguna acción.',
    countdown:
      'Apple y Google confirman la recepción en aprox. {{minutes}}m {{seconds}}s (alrededor de las {{time}}). Las estadísticas se actualizarán automáticamente.',
    ready: 'Los registros ya deberían estar. Los números a continuación se están actualizando.',
    soon: 'en breve',
  },
  recipients: {
    title: 'Destinatarios',
    subtitle: 'A quién se envió esta campaña y si llegó a su dispositivo.',
    filters: {
      all: 'Todos',
      delivered: 'Entregado',
      pending: 'Pendiente de confirmación',
      failed: 'No entregado',
    },
    columns: {
      recipient: 'Destinatario',
      status: 'Estado',
      reason: 'Motivo',
      clicked: 'Con clic',
      sent_at: 'Enviado el',
    },
    status: {
      delivered: 'Entregado',
      pending: 'Pendiente de confirmación',
      failed: 'No entregado',
    },
    reasons: {
      DeviceNotRegistered: 'App eliminada o notificaciones desactivadas (token expirado)',
      MessageRateExceeded: 'Limitación temporal de velocidad por Expo',
      MessageTooBig: 'Carga de notificación demasiado grande',
      MismatchSenderId: 'Credenciales de push no coinciden',
      InvalidCredentials: 'Credenciales de push no válidas',
      batch_failed: 'Error al enviar el lote',
      missing_ticket: 'Sin confirmación de Expo',
      unknown: 'Error de entrega desconocido',
    },
  },
};
